
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { ExportCenterListParams } from '@/typings/api/yuntuSales'

/**
 * ************************************** 导出中心 **************************************
 */
//  列表数据
export function businessList(data?: ExportCenterListParams) {
  return request.post<AxiosResult>('/base/api/export/findByPage', data)
}
//  下载地址
export function downloadGet(params?: {id?:number}) {
  return request.get<AxiosResult, any>('/base/api/export/download', { params })
}
//  删除接口
export function deleteExport(data?: {id?:number}) {
  return request.post<AxiosResult, any>('/base/api/export/delete', data)
}
